import React, { useState } from 'react';

import spark from '../../../../assets/img/spark.svg';
import s from './GenerateImage.module.css';
import {useAppDispatch} from "../../../../store/store";
import {generateImage} from "../../../../store/slices/projectSlice";
import Button from "../../../../shared/ui/button/Button";

interface GenerateImageProps {
    projectId?: string;

}

const GenerateImage: React.FC<GenerateImageProps> = ({ projectId }) => {
    const dispatch = useAppDispatch();
    const [promptImage, setPromptImage] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const handleGenerateImage = async () => {
        if (!promptImage.trim()) {
            setError('Please describe the image you have in mind.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            if(projectId){
                const result = await dispatch(generateImage({ projectId, prompt: promptImage })).unwrap();
            }


        } catch (err: any) {
            setError(err.message || 'Failed to generate image.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={s.container_generate}>
            <p>Describe the image you have in mind</p>
            <input
                className={s.input}
                value={promptImage}
                onChange={(e) => setPromptImage(e.target.value)}
                placeholder="E.g., London double-decker bus"
            />
            <Button
                icon={spark}
                iconPosition={'left'}
                text={loading ? 'Generating...' : 'Generate'}
                onClick={handleGenerateImage}
            />

        </div>
    );
};

export default GenerateImage;
